export default __webpack_public_path__ + "img/arrow-extern.db942c5.svg";